<template>
  <v-list v-if="errandMembers && mentionMode" class="mention-list" dense>
    <v-list-item
      v-for="(participant, index) in errandMembers.chatMentionParticipants"
      :key="participant.email"
      :class="{ 'mention-item-active': selectedMention === participant }"
      @click="selectMention(index)"
      >
      <v-list-item-content class="mention-text">{{ participant.name }}</v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>

export default {
  props: {
    mentionMode: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedMentionIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    selectedMention() {
      return this.errandMembers.chatMentionParticipants[this.selectedMentionIndex]
    }
  },
  methods: {
    selectMention(index) {
      this.publish('selectedMention', this.errandMembers.chatMentionParticipants[index])
    }
  }
}
</script>

<style lang="scss" scoped>
.mention-list {
  padding-bottom: 0px;
}

.mention-item-active {
  background-color: rgba(var(--color-medium-light), 0.5);
}

.mention-text{
  color: rgba(var(--color-jet), 0.8);
}

.v-list-item__content{
  padding: 0 !important;
}
</style>
